module.exports = __webpack_public_path__ + "img/replay_nav.1ee2c852.jpg";